import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { initialDataList } from '@interfaces/common/common.Interface'

export interface ChamCongState {
  chamCongList?: any
  viTriList?: any
  mangNoiBoList?: any
  caLamViecList?: any
  lichPhanCaList?: any
  mauCaList?: any
  chiTietCongList?: any
  tongHopCongList?: any
  thongKeList?: any
  reloadChamCongList?: string | null
}

const initialState: ChamCongState = {
  chamCongList: initialDataList,
  viTriList: initialDataList,
  mangNoiBoList: initialDataList,
  caLamViecList: initialDataList,
  lichPhanCaList: initialDataList,
  mauCaList: initialDataList,
  chiTietCongList: initialDataList,
  tongHopCongList: initialDataList,
  thongKeList: initialDataList,
  reloadChamCongList: null,
}

export const chamCongDucks = createSlice({
  name: 'chamCong',
  initialState,
  reducers: {
    // Chấm công
    layDanhSachChamCong: (state: RootState, action: PayloadAction<any>) => {
      state.chamCongList = { loading: true, queryStr: action.payload }
    },
    layDanhSachChamCongThanhCong: (state: RootState, action: PayloadAction<any>) => {
      state.chamCongList = { loading: false, ...action.payload }
    },
    layDanhSachChamCongThatBai: (state: RootState, action: PayloadAction<any>) => {
      state.chamCongList = { loading: false, ...action.payload }
    },

    // Vị trí
    layDanhSachViTri: (state: RootState, action: PayloadAction<any>) => {
      state.viTriList = { loading: true, queryStr: action.payload }
    },
    layDanhSachViTriThanhCong: (state: RootState, action: PayloadAction<any>) => {
      state.viTriList = { loading: false, ...action.payload }
    },
    layDanhSachViTriThatBai: (state: RootState, action: PayloadAction<any>) => {
      state.viTriList = { loading: false, ...action.payload }
    },

    // Mạng nội bộ
    layDanhSachMangNoiBo: (state: RootState, action: PayloadAction<any>) => {
      state.mangNoiBoList = { loading: true, queryStr: action.payload }
    },
    layDanhSachMangNoiBoThanhCong: (state: RootState, action: PayloadAction<any>) => {
      state.mangNoiBoList = { loading: false, ...action.payload }
    },
    layDanhSachMangNoiBoThatBai: (state: RootState, action: PayloadAction<any>) => {
      state.mangNoiBoList = { loading: false, ...action.payload }
    },

    // Ca làm việc
    layDanhSachCaLamViec: (state: RootState, action: PayloadAction<any>) => {
      state.caLamViecList = { loading: true, queryStr: action.payload }
    },
    layDanhSachCaLamViecThanhCong: (state: RootState, action: PayloadAction<any>) => {
      state.caLamViecList = { loading: false, ...action.payload }
    },
    layDanhSachCaLamViecThatBai: (state: RootState, action: PayloadAction<any>) => {
      state.caLamViecList = { loading: false, ...action.payload }
    },

    // Lịch phân ca
    layDanhSachLichPhanCa: (state: RootState, action: PayloadAction<any>) => {
      state.lichPhanCaList = { loading: true, queryStr: action.payload }
    },
    layDanhSachLichPhanCaThanhCong: (state: RootState, action: PayloadAction<any>) => {
      state.lichPhanCaList = { loading: false, ...action.payload }
    },
    layDanhSachLichPhanCaThatBai: (state: RootState, action: PayloadAction<any>) => {
      state.lichPhanCaList = { loading: false, ...action.payload }
    },

    // Mẫu ca
    layDanhSachMauCa: (state: RootState, action: PayloadAction<any>) => {
      state.mauCaList = { loading: true, queryStr: action.payload }
    },
    layDanhSachMauCaThanhCong: (state: RootState, action: PayloadAction<any>) => {
      state.mauCaList = { loading: false, ...action.payload }
    },
    layDanhSachMauCaThatBai: (state: RootState, action: PayloadAction<any>) => {
      state.mauCaList = { loading: false, ...action.payload }
    },

    // Chi tiết công
    layDanhSachChiTietCong: (state: RootState, action: PayloadAction<any>) => {
      state.chiTietCongList = { loading: true, queryStr: action.payload }
    },
    layDanhSachChiTietCongThanhCong: (state: RootState, action: PayloadAction<any>) => {
      state.chiTietCongList = { loading: false, ...action.payload }
    },
    layDanhSachChiTietCongThatBai: (state: RootState, action: PayloadAction<any>) => {
      state.chiTietCongList = { loading: false, ...action.payload }
    },

    // Tổng hợp công
    layDanhSachTongHopCong: (state: RootState, action: PayloadAction<any>) => {
      state.tongHopCongList = { loading: true, queryStr: action.payload }
    },
    layDanhSachTongHopCongThanhCong: (state: RootState, action: PayloadAction<any>) => {
      state.tongHopCongList = { loading: false, ...action.payload }
    },
    layDanhSachTongHopCongThatBai: (state: RootState, action: PayloadAction<any>) => {
      state.tongHopCongList = { loading: false, ...action.payload }
    },

    // Thống kê
    layDanhSachThongKe: (state: RootState, action: PayloadAction<any>) => {
      state.thongKeList = { loading: true, queryStr: action.payload }
    },
    layDanhSachThongKeThanhCong: (state: RootState, action: PayloadAction<any>) => {
      state.thongKeList = { loading: false, ...action.payload }
    },
    layDanhSachThongKeThatBai: (state: RootState, action: PayloadAction<any>) => {
      state.thongKeList = { loading: false, ...action.payload }
    },

    datTaiLaiDanhSachChamCong: (state: RootState) => {
      state.reloadChamCongList = String(Date.now())
    },
  },
})

export const {
  layDanhSachChamCong,
  layDanhSachChamCongThanhCong,
  layDanhSachChamCongThatBai,
  layDanhSachViTri,
  layDanhSachViTriThanhCong,
  layDanhSachViTriThatBai,
  layDanhSachMangNoiBo,
  layDanhSachMangNoiBoThanhCong,
  layDanhSachMangNoiBoThatBai,
  layDanhSachCaLamViec,
  layDanhSachCaLamViecThanhCong,
  layDanhSachCaLamViecThatBai,
  layDanhSachLichPhanCa,
  layDanhSachLichPhanCaThanhCong,
  layDanhSachLichPhanCaThatBai,
  layDanhSachMauCa,
  layDanhSachMauCaThanhCong,
  layDanhSachMauCaThatBai,
  layDanhSachChiTietCong,
  layDanhSachChiTietCongThanhCong,
  layDanhSachChiTietCongThatBai,
  layDanhSachTongHopCong,
  layDanhSachTongHopCongThanhCong,
  layDanhSachTongHopCongThatBai,
  layDanhSachThongKe,
  layDanhSachThongKeThanhCong,
  layDanhSachThongKeThatBai,
  datTaiLaiDanhSachChamCong,
} = chamCongDucks.actions

export default chamCongDucks.reducer
